import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import 'flickity-bg-lazyload';
import 'flickity-fade';
import 'flickity-as-nav-for';
import { throttle } from 'lodash';
import ImagesLoaded from 'imagesloaded';
import asNavFor from 'flickity-as-nav-for';

const MOS = {};
window.MOS = MOS;

(() => {
  const SCREENMDMAX = 1199;
  let winSize = 0;
  const calcWinSize = () => {
    winSize = { width: window.innerWidth, height: window.innerHeight };
  };
  const scrollTo = (elt, duration, target) => {
    console.log('scrollto', elt, duration, target);
    gsap.to(
      window,
      {
        duration: duration || 1,
        scrollTo: elt.getBoundingClientRect().top + window.scrollY,
        onComplete: () => {
          if (target !== undefined) {
            // window.location.hash = target;
          }
        },
      },
    );
  };

  const scrollToId = (href) => {
    if (href !== undefined) {
      const target = href.split('#')[1];
      if (document.getElementById(target) !== null) {
        scrollTo(document.getElementById(target), 1, target);
      }
    }
  };
  
  class Carousels {
    constructor(element) {
      if (element.querySelector('.js-carousel')) {
        console.log('Carousels::init', element.querySelectorAll('.js-carousel').length);
        const self = this;
        self.DOM = {
          elts: [],
          eltWrapper: element,
        };
        element.querySelectorAll('.js-carousel').forEach((elt) => {
          self.DOM.elts.push(elt);
        });
        self.flcks = [];
        self.init();
      }
    }
    init() {
      let idx = 0;
      const self = this;
      self.DOM.elts.forEach((instance) => {
        console.log('Carousels::init', idx);
        const flck = new Flickity(instance);
        if (self.DOM.eltWrapper.querySelector('.btn--next') && self.DOM.eltWrapper.querySelector('.btn--prev')) {
          self.DOM.eltWrapper.querySelector('.btn--next').addEventListener('click', (e) => {
            e.preventDefault();
            flck.next(true, false);
          });
          self.DOM.eltWrapper.querySelector('.btn--prev').addEventListener('click', (e) => {
            e.preventDefault();
            flck.previous(true, false);
          });
        }
        if (self.DOM.eltWrapper.querySelector('.c-carousel__info')) {
          self.DOM.infoItem = self.DOM.eltWrapper.querySelector('.c-carousel__info');
          self.DOM.infoItems = self.DOM.eltWrapper.querySelectorAll('.c-carousel__info-item');
          self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
          flck.on( 'change', self.onChange.bind(self));
          self.DOM.closeBtn.addEventListener('click', self.onClose.bind(self));
          self.isInfoClosed = false;
          if (winSize.width <= SCREENMDMAX) {
            self.onClose();
          }
        }
        self.flcks.push(flck);
        idx += 1;
      });
    }

    onChange(idx) {
      const self = this;
      console.log('info', this.DOM.infoItem , this.DOM.infoItems );
      self.DOM.infoItems.forEach((elt, index) => {
        if (index === idx) {
          elt.classList.add('is-active');
        } else {
          elt.classList.remove('is-active');
        }
      });
    }

    onClose() {
      const self = this;
      if (self.isInfoClosed) {
        self.DOM.infoItem.classList.add('is-opened');
        self.isInfoClosed = false;
      } else {
        self.DOM.infoItem.classList.remove('is-opened');
        self.isInfoClosed = true;
      }
    }
  }
  class DDMenuItem {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('button');
      this.DOM.content = this.DOM.elt.querySelector('.menu-item__level');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.init();
    }

    init() {
      const self = this;
      this.DOM.btn.addEventListener('click', self.toggleCurrent.bind(self));
    }

    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      if (action === 'SHOW') {
        gsap.to(this.DOM.content, { duration:0.3, height: 'auto' });
        this.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(this.DOM.content, { duration:0.3, height: 0 });
        this.DOM.elt.classList.remove('is-active');
      }
    }
  }

  class MainNav {
    constructor(elt, eltWrapper) {
      if (document.querySelector(elt) && document.querySelector(eltWrapper)) {
        const self = this;
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.eltWrapper = document.querySelector(eltWrapper);
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.openBtn = self.DOM.eltWrapper.querySelector('.btn-burger');
        self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
        this.DOM.menuLinks = this.DOM.elt.querySelectorAll('.menu__item a');
        self.isOpen = false;
        self.initEvents();
      }
    }
    initEvents() {
      const self = this;
      if (self.DOM.openBtn) {
        self.DOM.openBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (this.isOpen) {
            this.toggle('close');
          } else {
            this.toggle('open');
          }
        });
      }

      if (self.DOM.closeBtn) {
        self.DOM.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle('close');
        });
      }

      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach(item => this.menuItems.push(new DDMenuItem(item)));
    
      if (self.settings.sticky !== undefined && self.settings.sticky && winSize.width > SCREENMDMAX) {
        window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
      }

      self.DOM.menuLinks.forEach((elt) => {
        elt.addEventListener('click', (e) => {
          const href = e.currentTarget.getAttribute('href');
          const target = href.split('#')[1];
          if (document.getElementById(target) !== null) {
            MOS.mainNav.close();
          }
        });
      });
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.open();
      } else {
        self.close()
      }
    }

    open() {
      this.DOM.elt.classList.add('is-open');
      this.DOM.openBtn.classList.add('is-active');
      this.isOpen = true;
    }

    close() {
      this.DOM.elt.classList.remove('is-open');
      this.DOM.openBtn.classList.remove('is-active');
      this.isOpen = false;
    }

    onScroll(e) {
      const windowScrollY = window.scrollY;
      //200
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky') ;
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }

  function init() {
    let idx = 1;
    MOS.scrollPlugin = ScrollToPlugin;
    gsap.registerPlugin(ScrollToPlugin);
    MOS.mainNav = new MainNav('.c-main-nav', '.c-main-nav__wrapper');
    MOS.scrollPlugin = ScrollToPlugin;

    if (document.querySelector('.js-carousel-wrapper')) {
      MOS.carousels = [];
      document.querySelectorAll('.js-carousel-wrapper').forEach((element) => {
        MOS.carousels.push(new Carousels(element));
      });
    }

    if (document.querySelector('.btn-up')) {
      document.querySelector('.btn-up').addEventListener('click', () => {
        scrollTo(document.querySelector('body'));
      });
    }

    // hijack link with anchors & scroll to
    document.querySelectorAll('a[href^="#"]').forEach((elt) => {
      elt.addEventListener('click', (e) => {
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');
        if (href !== undefined) {
          const target = href.split('#')[1];
          if (document.getElementById(target) !== null) {
            scrollTo(document.getElementById(target));
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    calcWinSize();
    init();
  });
})();
